import WorkRequest from './WorkRequest';

export default WorkRequest;
